import _definePage_default_0 from '/www/wwwroot/qualiva/resources/js/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/www/wwwroot/qualiva/resources/js/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from '/www/wwwroot/qualiva/resources/js/pages/accreditation/self-assessment/index.vue?definePage&vue'
import _definePage_default_4 from '/www/wwwroot/qualiva/resources/js/pages/accreditation/self-assessment/[resultId]/index.vue?definePage&vue'
import _definePage_default_5 from '/www/wwwroot/qualiva/resources/js/pages/accreditation/self-assessment/[resultId]/public-summary.vue?definePage&vue'
import _definePage_default_6 from '/www/wwwroot/qualiva/resources/js/pages/accreditation/standards/index.vue?definePage&vue'
import _definePage_default_7 from '/www/wwwroot/qualiva/resources/js/pages/administration/approval-flows/index.vue?definePage&vue'
import _definePage_default_8 from '/www/wwwroot/qualiva/resources/js/pages/administration/backup/index.vue?definePage&vue'
import _definePage_default_9 from '/www/wwwroot/qualiva/resources/js/pages/administration/settings/index.vue?definePage&vue'
import _definePage_default_10 from '/www/wwwroot/qualiva/resources/js/pages/administration/update/index.vue?definePage&vue'
import _definePage_default_11 from '/www/wwwroot/qualiva/resources/js/pages/ai/chat.vue?definePage&vue'
import _definePage_default_12 from '/www/wwwroot/qualiva/resources/js/pages/ai/history.vue?definePage&vue'
import _definePage_default_13 from '/www/wwwroot/qualiva/resources/js/pages/ai/knowledge-base.vue?definePage&vue'
import _definePage_default_14 from '/www/wwwroot/qualiva/resources/js/pages/apps/roles/index.vue?definePage&vue'
import _definePage_default_15 from '/www/wwwroot/qualiva/resources/js/pages/apps/roles/[id]/edit.vue?definePage&vue'
import _definePage_default_16 from '/www/wwwroot/qualiva/resources/js/pages/apps/user/list/index.vue?definePage&vue'
import _definePage_default_17 from '/www/wwwroot/qualiva/resources/js/pages/assessment/results/index.vue?definePage&vue'
import _definePage_default_18 from '/www/wwwroot/qualiva/resources/js/pages/assessment/score/[templateId].vue?definePage&vue'
import _definePage_default_19 from '/www/wwwroot/qualiva/resources/js/pages/assessment/templates/index.vue?definePage&vue'
import _definePage_default_20 from '/www/wwwroot/qualiva/resources/js/pages/assessment/templates/create.vue?definePage&vue'
import _definePage_default_21 from '/www/wwwroot/qualiva/resources/js/pages/checklist/fill/[templateId].vue?definePage&vue'
import _definePage_default_22 from '/www/wwwroot/qualiva/resources/js/pages/checklist/results/index.vue?definePage&vue'
import _definePage_default_23 from '/www/wwwroot/qualiva/resources/js/pages/checklist/templates/index.vue?definePage&vue'
import _definePage_default_24 from '/www/wwwroot/qualiva/resources/js/pages/checklist/templates/[id]/edit.vue?definePage&vue'
import _definePage_default_25 from '/www/wwwroot/qualiva/resources/js/pages/checklist/templates/create.vue?definePage&vue'
import _definePage_default_26 from '/www/wwwroot/qualiva/resources/js/pages/clinical/formularium/index.vue?definePage&vue'
import _definePage_default_27 from '/www/wwwroot/qualiva/resources/js/pages/clinical/ppi-audit/index.vue?definePage&vue'
import _definePage_default_28 from '/www/wwwroot/qualiva/resources/js/pages/clinical/sop/index.vue?definePage&vue'
import _definePage_default_29 from '/www/wwwroot/qualiva/resources/js/pages/dashboards/index.vue?definePage&vue'
import _definePage_default_30 from '/www/wwwroot/qualiva/resources/js/pages/dashboards/analytics.vue?definePage&vue'
import _definePage_default_31 from '/www/wwwroot/qualiva/resources/js/pages/document/index.vue?definePage&vue'
import _definePage_default_32 from '/www/wwwroot/qualiva/resources/js/pages/document/[id]/index.vue?definePage&vue'
import _definePage_default_33 from '/www/wwwroot/qualiva/resources/js/pages/document/[id]/edit.vue?definePage&vue'
import _definePage_default_34 from '/www/wwwroot/qualiva/resources/js/pages/document/create.vue?definePage&vue'
import _definePage_default_35 from '/www/wwwroot/qualiva/resources/js/pages/forgot-password.vue?definePage&vue'
import _definePage_default_36 from '/www/wwwroot/qualiva/resources/js/pages/governance/kebijakan/index.vue?definePage&vue'
import _definePage_default_37 from '/www/wwwroot/qualiva/resources/js/pages/governance/organization-structure.vue?definePage&vue'
import _definePage_default_38 from '/www/wwwroot/qualiva/resources/js/pages/governance/sk/index.vue?definePage&vue'
import _definePage_default_39 from '/www/wwwroot/qualiva/resources/js/pages/help/index.vue?definePage&vue'
import _definePage_default_40 from '/www/wwwroot/qualiva/resources/js/pages/help/administrasi/aktivasi-lisensi.vue?definePage&vue'
import _definePage_default_41 from '/www/wwwroot/qualiva/resources/js/pages/help/administrasi/audit-log.vue?definePage&vue'
import _definePage_default_42 from '/www/wwwroot/qualiva/resources/js/pages/help/administrasi/backup-restore.vue?definePage&vue'
import _definePage_default_43 from '/www/wwwroot/qualiva/resources/js/pages/help/administrasi/dashboard-laporan.vue?definePage&vue'
import _definePage_default_44 from '/www/wwwroot/qualiva/resources/js/pages/help/administrasi/impersonate.vue?definePage&vue'
import _definePage_default_45 from '/www/wwwroot/qualiva/resources/js/pages/help/administrasi/kelola-role.vue?definePage&vue'
import _definePage_default_46 from '/www/wwwroot/qualiva/resources/js/pages/help/administrasi/kelola-user.vue?definePage&vue'
import _definePage_default_47 from '/www/wwwroot/qualiva/resources/js/pages/help/administrasi/master-data.vue?definePage&vue'
import _definePage_default_48 from '/www/wwwroot/qualiva/resources/js/pages/help/administrasi/pengaturan-smtp-ai.vue?definePage&vue'
import _definePage_default_49 from '/www/wwwroot/qualiva/resources/js/pages/help/administrasi/setup-approval-flow.vue?definePage&vue'
import _definePage_default_50 from '/www/wwwroot/qualiva/resources/js/pages/help/ai-assistant/chat-ai.vue?definePage&vue'
import _definePage_default_51 from '/www/wwwroot/qualiva/resources/js/pages/help/checklist/isi-checklist.vue?definePage&vue'
import _definePage_default_52 from '/www/wwwroot/qualiva/resources/js/pages/help/checklist/kelola-template-checklist.vue?definePage&vue'
import _definePage_default_53 from '/www/wwwroot/qualiva/resources/js/pages/help/dokumen/approval-dokumen.vue?definePage&vue'
import _definePage_default_54 from '/www/wwwroot/qualiva/resources/js/pages/help/dokumen/kelola-dokumen.vue?definePage&vue'
import _definePage_default_55 from '/www/wwwroot/qualiva/resources/js/pages/help/dokumen/lampiran-evidence.vue?definePage&vue'
import _definePage_default_56 from '/www/wwwroot/qualiva/resources/js/pages/help/fasilitas/checklist-mfk.vue?definePage&vue'
import _definePage_default_57 from '/www/wwwroot/qualiva/resources/js/pages/help/fasilitas/kalibrasi-alat.vue?definePage&vue'
import _definePage_default_58 from '/www/wwwroot/qualiva/resources/js/pages/help/kepegawaian/kredensial-pegawai.vue?definePage&vue'
import _definePage_default_59 from '/www/wwwroot/qualiva/resources/js/pages/help/kepegawaian/penilaian-kinerja.vue?definePage&vue'
import _definePage_default_60 from '/www/wwwroot/qualiva/resources/js/pages/help/kepegawaian/reminder-pengingat.vue?definePage&vue'
import _definePage_default_61 from '/www/wwwroot/qualiva/resources/js/pages/help/mutu/assessment-penilaian.vue?definePage&vue'
import _definePage_default_62 from '/www/wwwroot/qualiva/resources/js/pages/help/mutu/capa.vue?definePage&vue'
import _definePage_default_63 from '/www/wwwroot/qualiva/resources/js/pages/help/mutu/governance-organisasi.vue?definePage&vue'
import _definePage_default_64 from '/www/wwwroot/qualiva/resources/js/pages/help/mutu/indikator-mutu.vue?definePage&vue'
import _definePage_default_65 from '/www/wwwroot/qualiva/resources/js/pages/help/mutu/insiden-ikp.vue?definePage&vue'
import _definePage_default_66 from '/www/wwwroot/qualiva/resources/js/pages/help/mutu/layanan-klinis.vue?definePage&vue'
import _definePage_default_67 from '/www/wwwroot/qualiva/resources/js/pages/help/mutu/risk-register.vue?definePage&vue'
import _definePage_default_68 from '/www/wwwroot/qualiva/resources/js/pages/help/mutu/self-assessment-akreditasi.vue?definePage&vue'
import _definePage_default_69 from '/www/wwwroot/qualiva/resources/js/pages/help/mutu/task-tindak-lanjut.vue?definePage&vue'
import _definePage_default_70 from '/www/wwwroot/qualiva/resources/js/pages/help/onboarding.vue?definePage&vue'
import _definePage_default_71 from '/www/wwwroot/qualiva/resources/js/pages/help/rapat/rapat-mutu.vue?definePage&vue'
import _definePage_default_72 from '/www/wwwroot/qualiva/resources/js/pages/hr/employees/index.vue?definePage&vue'
import _definePage_default_73 from '/www/wwwroot/qualiva/resources/js/pages/hr/employees/[id]/credential.vue?definePage&vue'
import _definePage_default_74 from '/www/wwwroot/qualiva/resources/js/pages/hr/performance/index.vue?definePage&vue'
import _definePage_default_75 from '/www/wwwroot/qualiva/resources/js/pages/license/activate.vue?definePage&vue'
import _definePage_default_76 from '/www/wwwroot/qualiva/resources/js/pages/license/status.vue?definePage&vue'
import _definePage_default_77 from '/www/wwwroot/qualiva/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_78 from '/www/wwwroot/qualiva/resources/js/pages/master-data/assessment-categories/index.vue?definePage&vue'
import _definePage_default_79 from '/www/wwwroot/qualiva/resources/js/pages/master-data/checklist-categories/index.vue?definePage&vue'
import _definePage_default_80 from '/www/wwwroot/qualiva/resources/js/pages/master-data/contracts/index.vue?definePage&vue'
import _definePage_default_81 from '/www/wwwroot/qualiva/resources/js/pages/master-data/document-categories/index.vue?definePage&vue'
import _definePage_default_82 from '/www/wwwroot/qualiva/resources/js/pages/master-data/employees/index.vue?definePage&vue'
import _definePage_default_83 from '/www/wwwroot/qualiva/resources/js/pages/master-data/equipments/index.vue?definePage&vue'
import _definePage_default_84 from '/www/wwwroot/qualiva/resources/js/pages/master-data/facilities/index.vue?definePage&vue'
import _definePage_default_85 from '/www/wwwroot/qualiva/resources/js/pages/master-data/incident-types/index.vue?definePage&vue'
import _definePage_default_86 from '/www/wwwroot/qualiva/resources/js/pages/master-data/indicator-categories/index.vue?definePage&vue'
import _definePage_default_87 from '/www/wwwroot/qualiva/resources/js/pages/master-data/positions/index.vue?definePage&vue'
import _definePage_default_88 from '/www/wwwroot/qualiva/resources/js/pages/master-data/units/index.vue?definePage&vue'
import _definePage_default_89 from '/www/wwwroot/qualiva/resources/js/pages/master-data/vendors/index.vue?definePage&vue'
import _definePage_default_90 from '/www/wwwroot/qualiva/resources/js/pages/meeting/index.vue?definePage&vue'
import _definePage_default_91 from '/www/wwwroot/qualiva/resources/js/pages/meeting/[id]/index.vue?definePage&vue'
import _definePage_default_92 from '/www/wwwroot/qualiva/resources/js/pages/meeting/create.vue?definePage&vue'
import _definePage_default_93 from '/www/wwwroot/qualiva/resources/js/pages/mfk/checklist/index.vue?definePage&vue'
import _definePage_default_94 from '/www/wwwroot/qualiva/resources/js/pages/mfk/equipment/index.vue?definePage&vue'
import _definePage_default_95 from '/www/wwwroot/qualiva/resources/js/pages/mfk/facility/index.vue?definePage&vue'
import _definePage_default_96 from '/www/wwwroot/qualiva/resources/js/pages/not-authorized.vue?definePage&vue'
import _definePage_default_97 from '/www/wwwroot/qualiva/resources/js/pages/quality/capa/index.vue?definePage&vue'
import _definePage_default_98 from '/www/wwwroot/qualiva/resources/js/pages/quality/capa/[id]/index.vue?definePage&vue'
import _definePage_default_99 from '/www/wwwroot/qualiva/resources/js/pages/quality/incidents/index.vue?definePage&vue'
import _definePage_default_100 from '/www/wwwroot/qualiva/resources/js/pages/quality/incidents/[id]/index.vue?definePage&vue'
import _definePage_default_101 from '/www/wwwroot/qualiva/resources/js/pages/quality/incidents/create.vue?definePage&vue'
import _definePage_default_102 from '/www/wwwroot/qualiva/resources/js/pages/quality/indicators/index.vue?definePage&vue'
import _definePage_default_103 from '/www/wwwroot/qualiva/resources/js/pages/quality/indicators/[id]/index.vue?definePage&vue'
import _definePage_default_104 from '/www/wwwroot/qualiva/resources/js/pages/quality/risk-register/index.vue?definePage&vue'
import _definePage_default_105 from '/www/wwwroot/qualiva/resources/js/pages/reminder/index.vue?definePage&vue'
import _definePage_default_106 from '/www/wwwroot/qualiva/resources/js/pages/reports/index.vue?definePage&vue'
import _definePage_default_107 from '/www/wwwroot/qualiva/resources/js/pages/settings/[tab].vue?definePage&vue'
import _definePage_default_108 from '/www/wwwroot/qualiva/resources/js/pages/task/index.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('/www/wwwroot/qualiva/resources/js/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/www/wwwroot/qualiva/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/accreditation',
    /* internal name: 'accreditation' */
    /* no component */
    children: [
      {
        path: 'self-assessment',
        /* internal name: 'accreditation-self-assessment' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'accreditation-self-assessment',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/accreditation/self-assessment/index.vue'),
            /* no children */
          },
  _definePage_default_3
  ),
          {
            path: ':resultId',
            /* internal name: 'accreditation-self-assessment-result-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'accreditation-self-assessment-result-id',
                component: () => import('/www/wwwroot/qualiva/resources/js/pages/accreditation/self-assessment/[resultId]/index.vue'),
                /* no children */
              },
  _definePage_default_4
  ),
  _mergeRouteRecord(
              {
                path: 'public-summary',
                name: 'accreditation-self-assessment-result-id-public-summary',
                component: () => import('/www/wwwroot/qualiva/resources/js/pages/accreditation/self-assessment/[resultId]/public-summary.vue'),
                /* no children */
              },
  _definePage_default_5
  )
            ],
          }
        ],
      },
      {
        path: 'standards',
        /* internal name: 'accreditation-standards' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'accreditation-standards',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/accreditation/standards/index.vue'),
            /* no children */
          },
  _definePage_default_6
  )
        ],
      }
    ],
  },
  {
    path: '/administration',
    /* internal name: 'administration' */
    /* no component */
    children: [
      {
        path: 'approval-flows',
        /* internal name: 'administration-approval-flows' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'administration-approval-flows',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/administration/approval-flows/index.vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      },
      {
        path: 'backup',
        /* internal name: 'administration-backup' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'administration-backup',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/administration/backup/index.vue'),
            /* no children */
          },
  _definePage_default_8
  )
        ],
      },
      {
        path: 'settings',
        /* internal name: 'administration-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'administration-settings',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/administration/settings/index.vue'),
            /* no children */
          },
  _definePage_default_9
  )
        ],
      },
      {
        path: 'update',
        /* internal name: 'administration-update' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'administration-update',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/administration/update/index.vue'),
            /* no children */
          },
  _definePage_default_10
  )
        ],
      }
    ],
  },
  {
    path: '/ai',
    /* internal name: 'ai' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'chat',
        name: 'ai-chat',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/ai/chat.vue'),
        /* no children */
      },
  _definePage_default_11
  ),
  _mergeRouteRecord(
      {
        path: 'history',
        name: 'ai-history',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/ai/history.vue'),
        /* no children */
      },
  _definePage_default_12
  ),
  _mergeRouteRecord(
      {
        path: 'knowledge-base',
        name: 'ai-knowledge-base',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/ai/knowledge-base.vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  },
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'roles',
        /* internal name: 'apps-roles' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-roles',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/apps/roles/index.vue'),
            /* no children */
          },
  _definePage_default_14
  ),
          {
            path: ':id',
            /* internal name: 'apps-roles-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'apps-roles-id-edit',
                component: () => import('/www/wwwroot/qualiva/resources/js/pages/apps/roles/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_15
  )
            ],
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'apps-user' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-user-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-user-list',
                component: () => import('/www/wwwroot/qualiva/resources/js/pages/apps/user/list/index.vue'),
                /* no children */
              },
  _definePage_default_16
  )
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/assessment',
    /* internal name: 'assessment' */
    /* no component */
    children: [
      {
        path: 'results',
        /* internal name: 'assessment-results' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'assessment-results',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/assessment/results/index.vue'),
            /* no children */
          },
  _definePage_default_17
  )
        ],
      },
      {
        path: 'score',
        /* internal name: 'assessment-score' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':templateId',
            name: 'assessment-score-template-id',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/assessment/score/[templateId].vue'),
            /* no children */
          },
  _definePage_default_18
  )
        ],
      },
      {
        path: 'templates',
        /* internal name: 'assessment-templates' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'assessment-templates',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/assessment/templates/index.vue'),
            /* no children */
          },
  _definePage_default_19
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'assessment-templates-create',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/assessment/templates/create.vue'),
            /* no children */
          },
  _definePage_default_20
  )
        ],
      }
    ],
  },
  {
    path: '/checklist',
    /* internal name: 'checklist' */
    /* no component */
    children: [
      {
        path: 'fill',
        /* internal name: 'checklist-fill' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':templateId',
            name: 'checklist-fill-template-id',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/checklist/fill/[templateId].vue'),
            /* no children */
          },
  _definePage_default_21
  )
        ],
      },
      {
        path: 'results',
        /* internal name: 'checklist-results' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'checklist-results',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/checklist/results/index.vue'),
            /* no children */
          },
  _definePage_default_22
  )
        ],
      },
      {
        path: 'templates',
        /* internal name: 'checklist-templates' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'checklist-templates',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/checklist/templates/index.vue'),
            /* no children */
          },
  _definePage_default_23
  ),
          {
            path: ':id',
            /* internal name: 'checklist-templates-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'checklist-templates-id-edit',
                component: () => import('/www/wwwroot/qualiva/resources/js/pages/checklist/templates/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_24
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'checklist-templates-create',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/checklist/templates/create.vue'),
            /* no children */
          },
  _definePage_default_25
  )
        ],
      }
    ],
  },
  {
    path: '/clinical',
    /* internal name: 'clinical' */
    /* no component */
    children: [
      {
        path: 'formularium',
        /* internal name: 'clinical-formularium' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'clinical-formularium',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/clinical/formularium/index.vue'),
            /* no children */
          },
  _definePage_default_26
  )
        ],
      },
      {
        path: 'ppi-audit',
        /* internal name: 'clinical-ppi-audit' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'clinical-ppi-audit',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/clinical/ppi-audit/index.vue'),
            /* no children */
          },
  _definePage_default_27
  )
        ],
      },
      {
        path: 'sop',
        /* internal name: 'clinical-sop' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'clinical-sop',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/clinical/sop/index.vue'),
            /* no children */
          },
  _definePage_default_28
  )
        ],
      }
    ],
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'dashboards',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/dashboards/index.vue'),
        /* no children */
      },
  _definePage_default_29
  ),
  _mergeRouteRecord(
      {
        path: 'analytics',
        name: 'dashboards-analytics',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/dashboards/analytics.vue'),
        /* no children */
      },
  _definePage_default_30
  )
    ],
  },
  {
    path: '/document',
    /* internal name: 'document' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'document',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/document/index.vue'),
        /* no children */
      },
  _definePage_default_31
  ),
      {
        path: ':id',
        /* internal name: 'document-id' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'document-id',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/document/[id]/index.vue'),
            /* no children */
          },
  _definePage_default_32
  ),
  _mergeRouteRecord(
          {
            path: 'edit',
            name: 'document-id-edit',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/document/[id]/edit.vue'),
            /* no children */
          },
  _definePage_default_33
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'document-create',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/document/create.vue'),
        /* no children */
      },
  _definePage_default_34
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/www/wwwroot/qualiva/resources/js/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_35
  ),
  {
    path: '/governance',
    /* internal name: 'governance' */
    /* no component */
    children: [
      {
        path: 'kebijakan',
        /* internal name: 'governance-kebijakan' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'governance-kebijakan',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/governance/kebijakan/index.vue'),
            /* no children */
          },
  _definePage_default_36
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'organization-structure',
        name: 'governance-organization-structure',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/governance/organization-structure.vue'),
        /* no children */
      },
  _definePage_default_37
  ),
      {
        path: 'sk',
        /* internal name: 'governance-sk' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'governance-sk',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/governance/sk/index.vue'),
            /* no children */
          },
  _definePage_default_38
  )
        ],
      }
    ],
  },
  {
    path: '/help',
    /* internal name: 'help' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'help',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/index.vue'),
        /* no children */
      },
  _definePage_default_39
  ),
      {
        path: 'administrasi',
        /* internal name: 'help-administrasi' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'aktivasi-lisensi',
            name: 'help-administrasi-aktivasi-lisensi',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/administrasi/aktivasi-lisensi.vue'),
            /* no children */
          },
  _definePage_default_40
  ),
  _mergeRouteRecord(
          {
            path: 'audit-log',
            name: 'help-administrasi-audit-log',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/administrasi/audit-log.vue'),
            /* no children */
          },
  _definePage_default_41
  ),
  _mergeRouteRecord(
          {
            path: 'backup-restore',
            name: 'help-administrasi-backup-restore',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/administrasi/backup-restore.vue'),
            /* no children */
          },
  _definePage_default_42
  ),
  _mergeRouteRecord(
          {
            path: 'dashboard-laporan',
            name: 'help-administrasi-dashboard-laporan',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/administrasi/dashboard-laporan.vue'),
            /* no children */
          },
  _definePage_default_43
  ),
  _mergeRouteRecord(
          {
            path: 'impersonate',
            name: 'help-administrasi-impersonate',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/administrasi/impersonate.vue'),
            /* no children */
          },
  _definePage_default_44
  ),
  _mergeRouteRecord(
          {
            path: 'kelola-role',
            name: 'help-administrasi-kelola-role',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/administrasi/kelola-role.vue'),
            /* no children */
          },
  _definePage_default_45
  ),
  _mergeRouteRecord(
          {
            path: 'kelola-user',
            name: 'help-administrasi-kelola-user',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/administrasi/kelola-user.vue'),
            /* no children */
          },
  _definePage_default_46
  ),
  _mergeRouteRecord(
          {
            path: 'master-data',
            name: 'help-administrasi-master-data',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/administrasi/master-data.vue'),
            /* no children */
          },
  _definePage_default_47
  ),
  _mergeRouteRecord(
          {
            path: 'pengaturan-smtp-ai',
            name: 'help-administrasi-pengaturan-smtp-ai',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/administrasi/pengaturan-smtp-ai.vue'),
            /* no children */
          },
  _definePage_default_48
  ),
  _mergeRouteRecord(
          {
            path: 'setup-approval-flow',
            name: 'help-administrasi-setup-approval-flow',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/administrasi/setup-approval-flow.vue'),
            /* no children */
          },
  _definePage_default_49
  )
        ],
      },
      {
        path: 'ai-assistant',
        /* internal name: 'help-ai-assistant' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'chat-ai',
            name: 'help-ai-assistant-chat-ai',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/ai-assistant/chat-ai.vue'),
            /* no children */
          },
  _definePage_default_50
  )
        ],
      },
      {
        path: 'checklist',
        /* internal name: 'help-checklist' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'isi-checklist',
            name: 'help-checklist-isi-checklist',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/checklist/isi-checklist.vue'),
            /* no children */
          },
  _definePage_default_51
  ),
  _mergeRouteRecord(
          {
            path: 'kelola-template-checklist',
            name: 'help-checklist-kelola-template-checklist',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/checklist/kelola-template-checklist.vue'),
            /* no children */
          },
  _definePage_default_52
  )
        ],
      },
      {
        path: 'dokumen',
        /* internal name: 'help-dokumen' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'approval-dokumen',
            name: 'help-dokumen-approval-dokumen',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/dokumen/approval-dokumen.vue'),
            /* no children */
          },
  _definePage_default_53
  ),
  _mergeRouteRecord(
          {
            path: 'kelola-dokumen',
            name: 'help-dokumen-kelola-dokumen',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/dokumen/kelola-dokumen.vue'),
            /* no children */
          },
  _definePage_default_54
  ),
  _mergeRouteRecord(
          {
            path: 'lampiran-evidence',
            name: 'help-dokumen-lampiran-evidence',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/dokumen/lampiran-evidence.vue'),
            /* no children */
          },
  _definePage_default_55
  )
        ],
      },
      {
        path: 'fasilitas',
        /* internal name: 'help-fasilitas' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'checklist-mfk',
            name: 'help-fasilitas-checklist-mfk',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/fasilitas/checklist-mfk.vue'),
            /* no children */
          },
  _definePage_default_56
  ),
  _mergeRouteRecord(
          {
            path: 'kalibrasi-alat',
            name: 'help-fasilitas-kalibrasi-alat',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/fasilitas/kalibrasi-alat.vue'),
            /* no children */
          },
  _definePage_default_57
  )
        ],
      },
      {
        path: 'kepegawaian',
        /* internal name: 'help-kepegawaian' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'kredensial-pegawai',
            name: 'help-kepegawaian-kredensial-pegawai',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/kepegawaian/kredensial-pegawai.vue'),
            /* no children */
          },
  _definePage_default_58
  ),
  _mergeRouteRecord(
          {
            path: 'penilaian-kinerja',
            name: 'help-kepegawaian-penilaian-kinerja',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/kepegawaian/penilaian-kinerja.vue'),
            /* no children */
          },
  _definePage_default_59
  ),
  _mergeRouteRecord(
          {
            path: 'reminder-pengingat',
            name: 'help-kepegawaian-reminder-pengingat',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/kepegawaian/reminder-pengingat.vue'),
            /* no children */
          },
  _definePage_default_60
  )
        ],
      },
      {
        path: 'mutu',
        /* internal name: 'help-mutu' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'assessment-penilaian',
            name: 'help-mutu-assessment-penilaian',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/mutu/assessment-penilaian.vue'),
            /* no children */
          },
  _definePage_default_61
  ),
  _mergeRouteRecord(
          {
            path: 'capa',
            name: 'help-mutu-capa',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/mutu/capa.vue'),
            /* no children */
          },
  _definePage_default_62
  ),
  _mergeRouteRecord(
          {
            path: 'governance-organisasi',
            name: 'help-mutu-governance-organisasi',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/mutu/governance-organisasi.vue'),
            /* no children */
          },
  _definePage_default_63
  ),
  _mergeRouteRecord(
          {
            path: 'indikator-mutu',
            name: 'help-mutu-indikator-mutu',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/mutu/indikator-mutu.vue'),
            /* no children */
          },
  _definePage_default_64
  ),
  _mergeRouteRecord(
          {
            path: 'insiden-ikp',
            name: 'help-mutu-insiden-ikp',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/mutu/insiden-ikp.vue'),
            /* no children */
          },
  _definePage_default_65
  ),
  _mergeRouteRecord(
          {
            path: 'layanan-klinis',
            name: 'help-mutu-layanan-klinis',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/mutu/layanan-klinis.vue'),
            /* no children */
          },
  _definePage_default_66
  ),
  _mergeRouteRecord(
          {
            path: 'risk-register',
            name: 'help-mutu-risk-register',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/mutu/risk-register.vue'),
            /* no children */
          },
  _definePage_default_67
  ),
  _mergeRouteRecord(
          {
            path: 'self-assessment-akreditasi',
            name: 'help-mutu-self-assessment-akreditasi',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/mutu/self-assessment-akreditasi.vue'),
            /* no children */
          },
  _definePage_default_68
  ),
  _mergeRouteRecord(
          {
            path: 'task-tindak-lanjut',
            name: 'help-mutu-task-tindak-lanjut',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/mutu/task-tindak-lanjut.vue'),
            /* no children */
          },
  _definePage_default_69
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'onboarding',
        name: 'help-onboarding',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/onboarding.vue'),
        /* no children */
      },
  _definePage_default_70
  ),
      {
        path: 'rapat',
        /* internal name: 'help-rapat' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'rapat-mutu',
            name: 'help-rapat-rapat-mutu',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/help/rapat/rapat-mutu.vue'),
            /* no children */
          },
  _definePage_default_71
  )
        ],
      }
    ],
  },
  {
    path: '/hr',
    /* internal name: 'hr' */
    /* no component */
    children: [
      {
        path: 'employees',
        /* internal name: 'hr-employees' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'hr-employees',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/hr/employees/index.vue'),
            /* no children */
          },
  _definePage_default_72
  ),
          {
            path: ':id',
            /* internal name: 'hr-employees-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'credential',
                name: 'hr-employees-id-credential',
                component: () => import('/www/wwwroot/qualiva/resources/js/pages/hr/employees/[id]/credential.vue'),
                /* no children */
              },
  _definePage_default_73
  )
            ],
          }
        ],
      },
      {
        path: 'performance',
        /* internal name: 'hr-performance' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'hr-performance',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/hr/performance/index.vue'),
            /* no children */
          },
  _definePage_default_74
  )
        ],
      }
    ],
  },
  {
    path: '/license',
    /* internal name: 'license' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'activate',
        name: 'license-activate',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/license/activate.vue'),
        /* no children */
      },
  _definePage_default_75
  ),
  _mergeRouteRecord(
      {
        path: 'status',
        name: 'license-status',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/license/status.vue'),
        /* no children */
      },
  _definePage_default_76
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/www/wwwroot/qualiva/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_77
  ),
  {
    path: '/master-data',
    /* internal name: 'master-data' */
    /* no component */
    children: [
      {
        path: 'assessment-categories',
        /* internal name: 'master-data-assessment-categories' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-assessment-categories',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/assessment-categories/index.vue'),
            /* no children */
          },
  _definePage_default_78
  )
        ],
      },
      {
        path: 'checklist-categories',
        /* internal name: 'master-data-checklist-categories' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-checklist-categories',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/checklist-categories/index.vue'),
            /* no children */
          },
  _definePage_default_79
  )
        ],
      },
      {
        path: 'contracts',
        /* internal name: 'master-data-contracts' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-contracts',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/contracts/index.vue'),
            /* no children */
          },
  _definePage_default_80
  )
        ],
      },
      {
        path: 'document-categories',
        /* internal name: 'master-data-document-categories' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-document-categories',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/document-categories/index.vue'),
            /* no children */
          },
  _definePage_default_81
  )
        ],
      },
      {
        path: 'employees',
        /* internal name: 'master-data-employees' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-employees',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/employees/index.vue'),
            /* no children */
          },
  _definePage_default_82
  )
        ],
      },
      {
        path: 'equipments',
        /* internal name: 'master-data-equipments' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-equipments',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/equipments/index.vue'),
            /* no children */
          },
  _definePage_default_83
  )
        ],
      },
      {
        path: 'facilities',
        /* internal name: 'master-data-facilities' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-facilities',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/facilities/index.vue'),
            /* no children */
          },
  _definePage_default_84
  )
        ],
      },
      {
        path: 'incident-types',
        /* internal name: 'master-data-incident-types' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-incident-types',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/incident-types/index.vue'),
            /* no children */
          },
  _definePage_default_85
  )
        ],
      },
      {
        path: 'indicator-categories',
        /* internal name: 'master-data-indicator-categories' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-indicator-categories',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/indicator-categories/index.vue'),
            /* no children */
          },
  _definePage_default_86
  )
        ],
      },
      {
        path: 'positions',
        /* internal name: 'master-data-positions' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-positions',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/positions/index.vue'),
            /* no children */
          },
  _definePage_default_87
  )
        ],
      },
      {
        path: 'units',
        /* internal name: 'master-data-units' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-units',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/units/index.vue'),
            /* no children */
          },
  _definePage_default_88
  )
        ],
      },
      {
        path: 'vendors',
        /* internal name: 'master-data-vendors' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'master-data-vendors',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/master-data/vendors/index.vue'),
            /* no children */
          },
  _definePage_default_89
  )
        ],
      }
    ],
  },
  {
    path: '/meeting',
    /* internal name: 'meeting' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'meeting',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/meeting/index.vue'),
        /* no children */
      },
  _definePage_default_90
  ),
      {
        path: ':id',
        /* internal name: 'meeting-id' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'meeting-id',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/meeting/[id]/index.vue'),
            /* no children */
          },
  _definePage_default_91
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'meeting-create',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/meeting/create.vue'),
        /* no children */
      },
  _definePage_default_92
  )
    ],
  },
  {
    path: '/mfk',
    /* internal name: 'mfk' */
    /* no component */
    children: [
      {
        path: 'checklist',
        /* internal name: 'mfk-checklist' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mfk-checklist',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/mfk/checklist/index.vue'),
            /* no children */
          },
  _definePage_default_93
  )
        ],
      },
      {
        path: 'equipment',
        /* internal name: 'mfk-equipment' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mfk-equipment',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/mfk/equipment/index.vue'),
            /* no children */
          },
  _definePage_default_94
  )
        ],
      },
      {
        path: 'facility',
        /* internal name: 'mfk-facility' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mfk-facility',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/mfk/facility/index.vue'),
            /* no children */
          },
  _definePage_default_95
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/www/wwwroot/qualiva/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_96
  ),
  {
    path: '/profile',
    name: 'profile',
    component: () => import('/www/wwwroot/qualiva/resources/js/pages/profile.vue'),
    /* no children */
  },
  {
    path: '/quality',
    /* internal name: 'quality' */
    /* no component */
    children: [
      {
        path: 'capa',
        /* internal name: 'quality-capa' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'quality-capa',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/quality/capa/index.vue'),
            /* no children */
          },
  _definePage_default_97
  ),
          {
            path: ':id',
            /* internal name: 'quality-capa-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'quality-capa-id',
                component: () => import('/www/wwwroot/qualiva/resources/js/pages/quality/capa/[id]/index.vue'),
                /* no children */
              },
  _definePage_default_98
  )
            ],
          }
        ],
      },
      {
        path: 'incidents',
        /* internal name: 'quality-incidents' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'quality-incidents',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/quality/incidents/index.vue'),
            /* no children */
          },
  _definePage_default_99
  ),
          {
            path: ':id',
            /* internal name: 'quality-incidents-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'quality-incidents-id',
                component: () => import('/www/wwwroot/qualiva/resources/js/pages/quality/incidents/[id]/index.vue'),
                /* no children */
              },
  _definePage_default_100
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'quality-incidents-create',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/quality/incidents/create.vue'),
            /* no children */
          },
  _definePage_default_101
  )
        ],
      },
      {
        path: 'indicators',
        /* internal name: 'quality-indicators' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'quality-indicators',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/quality/indicators/index.vue'),
            /* no children */
          },
  _definePage_default_102
  ),
          {
            path: ':id',
            /* internal name: 'quality-indicators-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'quality-indicators-id',
                component: () => import('/www/wwwroot/qualiva/resources/js/pages/quality/indicators/[id]/index.vue'),
                /* no children */
              },
  _definePage_default_103
  )
            ],
          }
        ],
      },
      {
        path: 'risk-register',
        /* internal name: 'quality-risk-register' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'quality-risk-register',
            component: () => import('/www/wwwroot/qualiva/resources/js/pages/quality/risk-register/index.vue'),
            /* no children */
          },
  _definePage_default_104
  )
        ],
      }
    ],
  },
  {
    path: '/reminder',
    /* internal name: 'reminder' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'reminder',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/reminder/index.vue'),
        /* no children */
      },
  _definePage_default_105
  )
    ],
  },
  {
    path: '/reports',
    /* internal name: 'reports' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'reports',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/reports/index.vue'),
        /* no children */
      },
  _definePage_default_106
  )
    ],
  },
  {
    path: '/settings',
    /* internal name: 'settings' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':tab',
        name: 'settings-tab',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/settings/[tab].vue'),
        /* no children */
      },
  _definePage_default_107
  )
    ],
  },
  {
    path: '/task',
    /* internal name: 'task' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'task',
        component: () => import('/www/wwwroot/qualiva/resources/js/pages/task/index.vue'),
        /* no children */
      },
  _definePage_default_108
  )
    ],
  }
]
